export const ARTICLE_PATH = 'article'